import { render, staticRenderFns } from "./sendImage.vue?vue&type=template&id=da75063e&scoped=true&"
import script from "./sendImage.vue?vue&type=script&lang=js&"
export * from "./sendImage.vue?vue&type=script&lang=js&"
import style0 from "./sendImage.vue?vue&type=style&index=0&id=da75063e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da75063e",
  null
  
)

export default component.exports